import { render } from "./GridExtratoHistorico.vue?vue&type=template&id=6a7edd4a"
import script from "./GridExtratoHistorico.vue?vue&type=script&lang=js"
export * from "./GridExtratoHistorico.vue?vue&type=script&lang=js"

import exportComponent from "D:\\el\\projetos\\java\\trb-jdk-portalservicos\\client\\el-portal-servicos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__